import { LoginType } from '@websky/graphql';

export enum Steps {
	LogIn,
	EnterCode,
	Registration,
	SelectEmailOrFFP,
	WithoutFFP,
	Welcome
}

export interface LoginData {
	login: string;
	email?: string;
	loginType: LoginType;
	code?: string;
}

export enum LoginInputType {
	Email = 'Email',
	Phone = 'Phone',
	Text = 'Text'
}

export interface LoginTypeWithValue {
	type: LoginType;
	value: string;
}
